import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { changeQBRLastStep } from 'partner360/features/QBR'

import { IOnStepChangeFn, Navigation } from '../../../navigation'
import { selectIsQbrChanged } from '../steps/settingsStep/components/qbrSettingsForm'

import { QBR_DOCUMENT_UPLOAD_STEPS } from './configs'

import styles from './QbrLegacyDocumentNavigation.module.scss'

interface IQbrLegacyDocumentNavigationProps {
  currentStep: number
}

export const QbrLegacyDocumentNavigation: FC<IQbrLegacyDocumentNavigationProps> = ({
  currentStep,
}) => {
  const isSettingsWasUpdated = useSelector(selectIsQbrChanged)
  const dispatch = useAppDispatch()
  const onStepChange = useCallback<IOnStepChangeFn>(
    (newStep) => () => {
      dispatch(changeQBRLastStep(newStep))
    },
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <Navigation
        currentStep={currentStep}
        steps={QBR_DOCUMENT_UPLOAD_STEPS}
        onStepChange={onStepChange}
        isDisabled={isSettingsWasUpdated}
      />
    </div>
  )
}
